import { AnyAction } from 'redux';

import TRADE_HISTORY from 'actionTypes/tradeHistory';

const initialState = {
  tradeHistoryFilters: {
    years: [],
    symbols: [],
  },
  filtersLoading: false,
  tradeHistoryRecords: [],
  recordsLoading: false,
  tradeHistoryDaily: [],
  dailyLoading: false,
};

// eslint-disable-next-line default-param-last
const tradeHistoryReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case TRADE_HISTORY.FETCH_TRADE_HISTORY_FILTERS.LOAD: {
      return {
        ...state,
        filtersLoading: true,
      };
    }
    case TRADE_HISTORY.FETCH_TRADE_HISTORY_FILTERS.SUCCESS: {
      return {
        ...state,
        filtersLoading: false,
        tradeHistoryFilters: action.result.result,
      };
    }
    case TRADE_HISTORY.FETCH_TRADE_HISTORY_FILTERS.FAIL: {
      return {
        ...state,
        filtersLoading: false,
        tradeHistoryFilters: {
          years: [],
          symbols: [],
        },
      };
    }
    case TRADE_HISTORY.GET_TRADE_HISTORY_RECORDS.LOAD: {
      return {
        ...state,
        recordsLoading: true,
      };
    }
    case TRADE_HISTORY.GET_TRADE_HISTORY_RECORDS.SUCCESS: {
      return {
        ...state,
        recordsLoading: false,
        tradeHistoryRecords: action.result.result,
      };
    }
    case TRADE_HISTORY.GET_TRADE_HISTORY_RECORDS.FAIL: {
      return {
        ...state,
        recordsLoading: false,
        tradeHistoryRecords: [],
      };
    }
    case TRADE_HISTORY.GET_TRADE_HISTORY_DAILY.LOAD: {
      return {
        ...state,
        dailyLoading: true,
      };
    }
    case TRADE_HISTORY.GET_TRADE_HISTORY_DAILY.SUCCESS: {
      return {
        ...state,
        dailyLoading: false,
        tradeHistoryDaily: action.result.result,
      };
    }
    case TRADE_HISTORY.GET_TRADE_HISTORY_DAILY.FAIL: {
      return {
        ...state,
        dailyLoading: false,
        tradeHistoryDaily: [],
      };
    }
    default:
      return state;
  }
};

export default tradeHistoryReducer;
